import React from 'react';
import PropTypes from 'prop-types';
import icon from './i_error.png';

export default class ErrorTooltip extends React.Component {
    render() {
        const imgId = this.props.for ? this.props.for + '-error-img' : undefined;
        return (
            <a role="button" tabIndex="0" title={this.props.value.join("\n")}>
                <img id={imgId} src={icon} alt=" " role="presentation"/>
            </a>
        );
    }
}

ErrorTooltip.propTypes = {
    value: PropTypes.array,
    for: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/common/ErrorTooltip/index.js